import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { AppButton } from '../button/appButton';
import { ColorPalette } from '../../../styles/constants';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

interface Props {
  isOpen: boolean;
  message: string;
  onClose(): void;
  onConfirm(): void;
}

export function AppConfirmationDelete({
  isOpen,
  message,
  onClose,
  onConfirm,
}: Props): JSX.Element {
  return (
    <Dialog open={isOpen} fullWidth onClose={onClose} maxWidth="xs">
      <DialogContent
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: 200,
        }}
      >
        <DeleteForeverOutlinedIcon
          sx={{ color: ColorPalette.WARNING_RED }}
          fontSize="large"
        />
        <Typography variant="h6" sx={{ mt: 3 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 0 }}>
        <AppButton label="Keep" onClick={onClose} />
        <AppButton
          label="Delete"
          sx={{ color: ColorPalette.WARNING_RED }}
          onClick={onConfirm}
        />
      </DialogActions>
    </Dialog>
  );
}
